import React from 'react'

export default function DotLink() {
    return (
        <div className='flex flex-row w-auto middle m-4'>
            <div className='border border-purple-700 dots bg-gray-400'></div>
            <div className='border border-purple-700 dots bg-gray-400'></div>
            <div className='border border-purple-700 dots bg-gray-400'></div>
        </div>
    )
}
